$(document).ready(function () {
    $('#shopify-section-cart .cart-table .cart__row .quantity input[name="updates[]"]').change(function (e) {
        e.preventDefault();
        $('#shopify-section-cart .cart-form').submit();
    })
    function nextHandler(pageIndex) {
        console.log(pageIndex)
        var url = window.location.href + `?page=${pageIndex+1}`;
        console.log(url)
        return fetch(url)
          .then(response => response.text())
          .then((data) => {
            let frag = document.createDocumentFragment();
      
            let totalPages = $('.pagination li').length - 2;
    
            var elements = $('<div />').append(data).find('article.product--root');
            for (let index = 0; index < elements.length; index++) {
                const element = elements[index];
                frag.appendChild(element);
            }
            let hasNextPage = pageIndex <= totalPages;
      
            return this.append(Array.from(frag.childNodes))
              // indicate that there is a next page to load
              .then(() => hasNextPage);
          });
    }
      
    window.ias = new InfiniteAjaxScroll('.collection-product-list', {
        item: '.product--root',
        next: nextHandler,
        pagination: false,
    });
})
  
  
  
